import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertPadelService {
  private alertEvent = new Subject<any>();

  // Observable for components to subscribe to
  alertEvent$ = this.alertEvent.asObservable();

  // Method to emit an alert event
  showAlert(data: {
    severity: string;
    summary: string;
    detail: string;
    key?: string;
    life?: number;
  }) {
    this.alertEvent.next(data);
  }
}
